var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('router-link',{attrs:{"to":_vm.path ? _vm.path :''}},[_c('img',{staticClass:"img-logo",attrs:{"src":require("../../assets/320x480/LogoYipi_Verde.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }